var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"phiolet_button p1b w-100",class:{'loading-button': _vm.loading},attrs:{"type":"button"},on:{"click":_vm.sendCpRequest}},[(_vm.loading)?_c('span',[_vm._v("Sending...")]):_c('span',[_vm._v("Request CrossProm")])])}
var staticRenderFns = []

export { render, staticRenderFns }